"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const useMergeRefs_1 = __importDefault(require("../../hooks/useMergeRefs"));
const Icon_1 = __importDefault(require("../Icon/Icon"));
const ListItemIconConstants_1 = require("./ListItemIconConstants");
require("./ListItemIcon.scss");
const ListItemIcon = (0, react_1.forwardRef)(({ className, id, icon, margin = ListItemIconConstants_1.ListItemIconMargin.START }, ref) => {
    const componentRef = (0, react_1.useRef)(null);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ ref: mergedRef, className: (0, classnames_1.default)("list-item-icon", className, `list-item-icon--${margin}`), id: id, "aria-hidden": "true" }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { icon: icon, clickable: false, ignoreFocusStyle: true, iconSize: 18 }) })));
});
Object.assign(ListItemIcon, {
    margin: ListItemIconConstants_1.ListItemIconMargin
});
exports.default = ListItemIcon;
